/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "htmlFor" }] */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Input, Spin } from 'antd';
import { findSenderContacts } from '../../../../actions/senderContacts';
import { formatValidFaxNumber } from '../../../../global/validation';

const ContactPicker = ({ initialContacts, onSelect }) => {
  const [query, setQuery] = useState('');
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!query.trim()) {
      setLoading(false);
      setError('');
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const result = await findSenderContacts({ query }, controller.signal);
        if (result && !controller.signal.aborted) { setContacts(result.contacts); setError(''); }
      } catch (exception) {
        if (!controller.signal.aborted) setError(exception.message);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [query, initialContacts]);

  const visibleContacts = query.trim() ? contacts : initialContacts;

  return (
    <div className="sender-contact-picker">
      <label htmlFor="sender-contact-search">Find an existing contact</label>
      <Input id="sender-contact-search" autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search office, person or fax number" />
      {error && <Alert type="error" message={error} />}
      <Spin spinning={Boolean(query.trim()) && loading}>
        <div className="sender-contact-picker__results">
          {visibleContacts.map((contact) => (
            <button type="button" key={contact.id} onClick={() => onSelect(contact)}>
              <span>
                <strong>{contact.organization_name || contact.contact_name || 'Unnamed contact'}</strong>
                {contact.organization_name && contact.contact_name && <small>{contact.contact_name}</small>}
              </span>
              <span>{formatValidFaxNumber(contact.contact)}</span>
            </button>
          ))}
          {!loading && !visibleContacts.length && <p>{query ? 'No matching contacts.' : 'Search to find a saved contact.'}</p>}
        </div>
      </Spin>
    </div>
  );
};

ContactPicker.propTypes = { initialContacts: PropTypes.array.isRequired, onSelect: PropTypes.func.isRequired };
export default ContactPicker;
